module.exports = __webpack_public_path__ + "img/header.ada2bb5e.svg";